import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useEffect, useRef } from "react";
import CardList from "./CardList";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import MediaQuery from 'react-responsive';
import { StickyContainer } from 'react-sticky';
import { AccordionToggle } from "../menu/AccordionToggle";
import uniqueId from 'lodash.uniqueid';
import Heading from '../heading/Heading';
import Wrapper from "../wrapper/Wrapper"; //ga tracker

import gaTracker from '../../util/ga-analytics/gaTracker';

var TextWCardList = function TextWCardList(props) {
  var layout = props.layout,
      _props$cardDisplayTyp = props.cardDisplayType,
      cardDisplayType = _props$cardDisplayTyp === void 0 ? "list" : _props$cardDisplayTyp,
      _props$totalCardsInRo = props.totalCardsInRow,
      totalCardsInRow = _props$totalCardsInRo === void 0 ? 3 : _props$totalCardsInRo,
      categoryLink = props.categoryLink,
      showArrows = props.showArrows;
  var accordionId = typeof categoryLink === 'string' && categoryLink ? categoryLink.replace(/\//g, '').toLowerCase() : uniqueId();
  return /*#__PURE__*/React.createElement(Wrapper, {
    layout: layout
  }, /*#__PURE__*/React.createElement("div", {
    className: "scrollToNavMenu"
  }, /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: 990
  }, /*#__PURE__*/React.createElement(Container, {
    className: "cb-menu__list"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Accordion, null, /*#__PURE__*/React.createElement(CardListTitle, props), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(CardListContent, _extends({}, props, {
    totalCardsInRow: totalCardsInRow,
    cardDisplayType: "list",
    showArrows: false // showArrows={showArrows}

  }))))))))), /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 991
  }, /*#__PURE__*/React.createElement(DesktopTitleCardList, _extends({}, props, {
    totalCardsInRow: totalCardsInRow,
    cardDisplayType: cardDisplayType,
    showArrows: showArrows
  })))));
};

export var DesktopTitleCardList = function DesktopTitleCardList(props) {
  return /*#__PURE__*/React.createElement(Container, {
    className: "cb-menu__list_desktop"
  }, /*#__PURE__*/React.createElement(Row, null, props.simple ? /*#__PURE__*/React.createElement(CardListSimpleTitle, props) : /*#__PURE__*/React.createElement(CardListTitle, props)), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(CardListContent, _extends({}, props, {
    isPromoProduct: true
  })))));
};

var titleClick = function titleClick(title, id) {
  var data = {
    gtm: {
      uniqueEventId: 78,
      elementTarget: title,
      elementId: id
    },
    event: 'gtm.click'
  };
  gaTracker(data);
};

export var CardListTitle = function CardListTitle(props) {
  var title = props.title,
      categoryLink = props.categoryLink,
      description = props.description,
      toRender = props.toRender,
      leftAligned = props.leftAligned;
  var subTitle = description || (toRender === null || toRender === void 0 ? void 0 : toRender.Description);
  useEffect(function () {
    var path = window.location.pathname.toLowerCase();

    if ((categoryLink === null || categoryLink === void 0 ? void 0 : categoryLink.toLowerCase()) === path) {
      window.setTimeout(function () {
        var _document$getElementB;

        return (_document$getElementB = document.getElementById(categoryLink === null || categoryLink === void 0 ? void 0 : categoryLink.toLowerCase())) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }, 500);
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    id: categoryLink === null || categoryLink === void 0 ? void 0 : categoryLink.toLowerCase(),
    onClick: function onClick() {
      return titleClick(title.value, categoryLink);
    },
    className: "cb-menu__list_desktop__heading-container\n        ".concat(leftAligned ? "" : "cb-type--center", "\n        w-100 pb-40\n      ")
  }, /*#__PURE__*/React.createElement(Heading, {
    level: "2",
    field: title,
    className: "cb-card__category-title"
  }), subTitle && subTitle !== "" && /*#__PURE__*/React.createElement("h3", {
    className: "cb-type__subtitle"
  }, subTitle), props.children);
};
export var CardListSimpleTitle = function CardListSimpleTitle(props) {
  var title = props.title,
      categoryLink = props.categoryLink,
      description = props.description;
  return /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Heading, {
    level: "3",
    field: title,
    className: "ml-3 cb-type__subtitle cb-menu__list_desktop__simple-title"
  }), props.children);
};
export var CardListContent = function CardListContent(props, index) {
  var _props$totalCardsInRo2 = props.totalCardsInRow,
      totalCardsInRow = _props$totalCardsInRo2 === void 0 ? 0 : _props$totalCardsInRo2,
      _props$isProduct = props.isProduct,
      isProduct = _props$isProduct === void 0 ? true : _props$isProduct,
      _props$isPromoProduct = props.isPromoProduct,
      isPromoProduct = _props$isPromoProduct === void 0 ? false : _props$isPromoProduct,
      cards = props.cards;
  var updatedLayout = {
    padding: "none",
    topPadding: "none",
    bottomPadding: "none"
  };
  return /*#__PURE__*/React.createElement(CardList, _extends({}, props, {
    isProduct: isProduct,
    totalCardsInRow: totalCardsInRow,
    layout: updatedLayout,
    isPromoProduct: isPromoProduct,
    cards: cards
  }));
};
export default TextWCardList;